import BaseComponentV2 from '../../../../../../library/js/components/base-component-v2';

export default class ToggleElementComponent extends BaseComponentV2 {

  constructor(element) {
    super(element);

    this.multiToggleInputElements = {};
    const self = this;


    this.element.each(function() {
      if (this.hasAttribute('data-inputgroupname')) {
        self.handleMultToggle(this);

      } else {
        self.handleSingleToggle(this);
      }
    });
  };

  handleSingleToggle(element) {

    const inputName = $(element).attr('data-inputname');
    $(element).append('<input type="hidden" name="' + inputName + '" />');
    const inputElement = $(element).find('input');
    inputElement.val($(element).attr('data-inputdefaultvalue'));

    function update() {

      const val = inputElement.val();

      if (val === '' || val === '0') {
        $(element).removeClass('selected');

      } else {
        $(element).addClass('selected');
      }
    }

    $(element).on('click', function() {
      const val = inputElement.val();
      val === '' || val === '0' ? inputElement.val(1) : inputElement.val('');

      update();
    });

    update();
  }

  handleMultToggle(element) {

    const inputName = $(element).attr('data-inputgroupname');
    const inputValue = $(element).attr('data-inputvalue');

    if (!this.multiToggleInputElements[inputName]) {
      const inputElement = $('<input type="hidden" name="' + inputName + '" />');
      inputElement.val($(element).attr('data-inputdefaultvalue'));
      $(element).append(inputElement);
      this.multiToggleInputElements[inputName] = inputElement;
    }

    const inputElement = this.multiToggleInputElements[inputName];

    function update() {

      const selectedValue = inputElement.val();

      $('[data-inputgroupname="' + inputName + '"]').each(function() {
        $(this).removeClass('selected');

        if ($(this).attr('data-inputvalue') === selectedValue) {
          $(this).addClass('selected');
        }
      });
    }

    $(element).on('click', () => {

      if (inputElement.val() !== inputValue) {
        inputElement.val(inputValue);
        update();
        inputElement.trigger('change', inputValue);
      }
    });

    update();
  }

}
